var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"e3-svg",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":Number(_vm.size),"height":Number(_vm.size),"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"fill":"currentColor","d":"M19.36 6.77L17.23 4.64 12 9.88 6.77 4.64 4.64 6.77 9.88 12 4.64 17.23 6.77 19.36 12 14.12 17.23 19.36 19.36 17.23 14.12 12 19.36 6.77z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }